import { css } from '@emotion/react';
import { type FC } from 'react';
import {
  ButtonComponent, ButtonStyle,
} from '~/_shared/baseComponents/buttons';
import { ModalComponent } from '~/_shared/components/modal/modal.component';
import { useTranslation } from '~/_shared/utils/hooks';
import { type ModalProps } from '~/modal/modalType.enum';

const contentStyle = css({
  padding: '20px 25px',
});

const textStyle = css({
  fontSize: 16,
});

export type MobileUseDesktopModalProps = ModalProps<{
  onContinueOnMobile: () => void;
}>;

export const MobileUseDesktopModalComponent: FC<MobileUseDesktopModalProps> = ({ isOpen, onClose, onContinueOnMobile }) => {
  const [t] = useTranslation();

  const handleContinueOnMobileClick = () => {
    onClose();
    onContinueOnMobile();
  };

  return (
    <ModalComponent
      caption={t('mobileUseDesktopModal.title')}
      confirmButton={(
        <ButtonComponent
          onClick={handleContinueOnMobileClick}
          text={t('mobileUseDesktopModal.continueOnMobileButton')}
        />
      )}
      contentStyle={contentStyle}
      isOpen={isOpen}
      leftFooterContent={(
        <ButtonComponent
          buttonStyle={ButtonStyle.Secondary}
          onClick={onClose}
          text={t('mobileUseDesktopModal.continueOnDesktopButton')}
        />
      )}
      onClose={onClose}
    >
      <div css={textStyle}>
        {t('mobileUseDesktopModal.recommendation')}
      </div>
    </ModalComponent>
  );
};
